export { colors } from "./colors"
export { default as SourceKeys } from "./sourceKeys"
export { default as SourceMapSalesChannel } from "./sourceMapSalesChannel"
export { default as PageName } from "./pageName"
import getConfig from "next/config"

const { publicRuntimeConfig: config } = getConfig()

export const host = ""

export const recaptchaSiteKey = config.recaptchaSiteKey
export const tencentAppId = config.tencentAppId

export const maxAllowedFileSize = 2 * 1024 * 1024

export const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined"
export const TokenCookiesKey = "otaToken"

export const uploadStatus = {
  init: "init",
  pending: "pending",
  inProgress: "in-progress",
  done: "done",
  error: "error"
}

export const mobileXSize = "375px"
export const mobileSize = "767px"
export const tabletSize = "1023px"
export const tabletXLSize = "1130px"

export const headerHeight = {
  mobile: "height: 52px",
  tablet: "height: 67px",
  desktop: "height: 77px"
}

export const zIndex = {
  header: "z-index: 900",
  floatingTop: "z-index: 910",
  floatingBottom: "z-index: 920",
  popup: "z-index: 1000",
  popupModal: "z-index: 1001",
  selectBase: "z-index: 10",
  selectBaseList: "z-index: 11",
  regionSelects: "z-index: 210",
  nobSelects: "z-index: 200",
  loading: "z-index:9999"
}

export const userSelect = `
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

export const transition = `
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
`

export const truncated = `
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const SubscriptionFormSteps = {
  landing: "NEW",
  details: "DETAIL",
  payment: "CONFIRM"
}

export const UploadState = {
  pending: "pending",
  done: "done",
  error: "error"
}
